import { Col } from "react-bootstrap";
import VideoPlayer from "../../components/VideoPlayer";
import { useEffect, useState } from "react";

export const EventResolvingVideo = ({
  src,
  taskType,
  task,
  selectedBoxes = [],
  showBoxes,
  showAll,
  expanded,
  setEnabled,
  videoRef,
  onMouseDownHandler,
}) => {
  const [tracks, setTracks] = useState({});
  const [colors, setColors] = useState({});
  const [duration, setDuration] = useState(0);
  const [videoProps, setVideoProps] = useState({
    autoPlay: true,
    muted: false,
  });

  useEffect(() => {
    if (!task?.boxes) return;

    let tracks = {};
    if (showBoxes) {
      if (showAll) {
        tracks = task.boxes;
      } else {
        const trackIds = [
          ...task.candidates_active,
          ...task.candidates_passive,
          ...Object.keys(task.additional_tracks),
        ];
        const boxes = {};
        for (const trackId of trackIds) {
          boxes[trackId] = task.boxes[trackId];
        }
        tracks = boxes;
      }
    } else {
      for (const trackId of selectedBoxes) {
        tracks = { ...tracks, [trackId]: task.boxes[trackId] };
      }
    }
    setTracks(tracks);
  }, [task, showBoxes, selectedBoxes, showAll]);

  useEffect(() => {
    if (!task || !selectedBoxes) return;

    const trackColors = {};
    if (task.additional_tracks) {
      for (let id in task.additional_tracks) {
        const [r, g, b] = task.additional_tracks[id];
        trackColors[id] = `rgb(${r}, ${g}, ${b})`;
      }
    }
    for (const trackId of selectedBoxes) trackColors[trackId] = "red";
    setColors(trackColors);
  }, [task, selectedBoxes]);

  const onVideoLoad = () => {
    setDuration(videoRef.current.duration);
  };

  const onFrameChange = (currentFrame) => {
    if (
      taskType === "event" ||
      (currentFrame >= task.frame_start && currentFrame <= task.frame_end)
    )
      setEnabled(true);
    else setEnabled(false);
  };

  return (
    <>
      <div className="tw-flex tw-justify-center">
        <Col xs={12}>
          {task ? (
            <VideoPlayer
              src={src}
              fps={task.fps}
              frameStep={task.frame_step}
              startTime={
                expanded
                  ? Math.max(task.frame_start * (1 / task.fps) - 10, 0)
                  : task.frame_start * (1 / task.fps)
              }
              endTime={
                expanded
                  ? Math.min(task.frame_end * (1 / task.fps) + 10, duration)
                  : task.frame_end * (1 / task.fps)
              }
              tracks={tracks}
              ref={videoRef}
              videoProps={videoProps}
              colors={colors}
              zoomArea={task.zoom_area_coordinates}
              timeStamps={
                expanded
                  ? [
                      {
                        time: task.frame_start * (1 / task.fps),
                        color: "#3366ff",
                      },
                      {
                        time: task.frame_end * (1 / task.fps),
                        color: "#3366ff",
                      },
                    ]
                  : []
              }
              loop={taskType === "ball_touch" ? false : true}
              onVideoLoadHandler={onVideoLoad}
              onFrameChange={onFrameChange}
              onMouseDownHandler={onMouseDownHandler}
            />
          ) : null}
        </Col>
      </div>
    </>
  );
};
